import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles';

const useStyles = makeStyles(styles);

// Generic removable, optionally-clickable pill. Stays display-only on
// purpose — interactive editors live in the host (see lib/README.md §8
// rule 5: side effects belong to the caller).
const EntityChip = ({
  label,
  badge,
  onEdit,
  onRemove,
  editable,
  editTitle,
  disabled,
  selected,
}) => {
  const classes = useStyles();

  const handleClick = () => {
    if (disabled || !editable || !onEdit) return;
    onEdit();
  };

  const handleRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || !onRemove) return;
    onRemove();
  };

  const isInteractive = !disabled && ((editable && !!onEdit) || !!onRemove);

  return (
    <div
      className={classnames(
        classes.chip,
        !isInteractive && classes.chipStatic,
        selected && classes.chipSelected,
        disabled && classes.chipDisabled,
      )}
      onClick={handleClick}
      title={editable && editTitle ? editTitle : undefined}
    >
      <span className={classes.chipLabel}>{label}</span>
      {badge && (
        typeof badge === 'string'
          ? <span className={classes.chipBadge}>{badge}</span>
          : badge
      )}
      {onRemove && !disabled && (
        <IconButton
          size="small"
          className={classes.removeIcon}
          onClick={handleRemove}
          aria-label="remove"
          disableRipple
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
};

EntityChip.propTypes = {
  label: propTypes.string.isRequired,
  badge: propTypes.node,
  onEdit: propTypes.func,
  onRemove: propTypes.func,
  editable: propTypes.bool,
  editTitle: propTypes.string,
  disabled: propTypes.bool,
  selected: propTypes.bool,
};

EntityChip.defaultProps = {
  badge: null,
  onEdit: undefined,
  onRemove: undefined,
  editable: true,
  editTitle: undefined,
  disabled: false,
  selected: false,
};

export default EntityChip;
